import {graphql} from 'react-relay';

export const BaselineEditPageQuery = graphql`
	query BaselineEditPageQuery($projectId: String, $hasDeliverablesFeature: Boolean!) {
		viewer {
			actualPersonId
			component(name: "edit_baseline")
			project(id: $projectId) {
				id
			}
			...BaselineEditPage_viewer @arguments(projectId: $projectId, hasDeliverablesFeature: $hasDeliverablesFeature)
		}
	}
`;
